"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useResponsiveMode = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = require("react");

var _getResponsiveMode = require("./getResponsiveMode");

/**
 * React effect hook which reports the current responsive mode, updating on
 * window resize when the responsive mode has changed.
 */
var useResponsiveMode = function useResponsiveMode() {
  var _useState = (0, _react.useState)((0, _getResponsiveMode.getResponsiveMode)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];

  (0, _react.useEffect)(function () {
    var lastMode = mode;

    var onResize = function onResize() {
      var newMode = (0, _getResponsiveMode.getResponsiveMode)();

      if (newMode !== lastMode) {
        lastMode = newMode;
        setMode(newMode);
      }
    };

    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, []);
  return mode;
};

exports.useResponsiveMode = useResponsiveMode;